package one.healthium.insights.domain.models

sealed interface ColorModel {
    data class Hex(val color: Long) : ColorModel
    data class Theme(val color: ThemeColor) : ColorModel
}

enum class ThemeColor {
    Primary,
    Secondary,
}